import React, { useState } from 'react';
import { QRCode } from 'react-qrcode-logo';




export default function QrcodeMaker() {

    const [QRcode, setQRcode] = useState(null);
    const qrSize = 1000;


    const downloadQRCode = (name) => {
        const canvas = document.getElementById("QR");
        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = `${name}.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };



    return (
        <>
            <div >
                <input type='text' onChange={(e)=>{
                    setQRcode(e.target.value)
                }}/>

                <div className='canvas-qr-card'>
                    <QRCode
                        value={`${QRcode}`}
                        size={qrSize}
                        logoImage={"/logo.png"}
                        fgColor={"#000"}
                        removeQrCodeBehindLogo={false}
                        quietZone={5}
                        eyeRadius={[
                            { // top/left eye
                                outer: [10, 10, 0, 10],
                                inner: [0, 10, 10, 10],
                            },
                            [10, 10, 10, 0], // top/right eye
                            [10, 0, 10, 10], // bottom/left
                        ]}
                        enableCORS={true}
                        logoWidth={qrSize / 2}
                        logoHeight={qrSize / 2}
                        logoOpacity={0.4}
                        ecLevel={'Q'}
                        qrStyle={"dots"} // squares
                        id={"QR"}
                    />
                </div>
                <div>
                    <button onClick={() => downloadQRCode("qrcode")} value="Download" className="px-4 w-full py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300">
                        Downlad
                    </button>
                </div>
            </div>
        </>
    )



}





